export default "__VITE_ASSET__20f47804__"